const deliveryAddressFormDefaultState = {
    address: '',
    instructions: '',
    lat: 0.0,
    lng: 0.0,
    error: false,
    success: false,
    loading: false,
};

export default (state = deliveryAddressFormDefaultState, action) => {

    switch(action.type) {

        case 'DELIVERY_ADDRESS_FORM_UPDATE':
            return {
                ...state,
                [action.field.prop]: action.field.value
            }

        case "DELIVERY_ADDRESS_FORM_SUCCESS":

            return {
                ...state,
                loading: false,
                error: false
            };

        case "DELIVERY_ADDRESS_FORM_ERROR":
            return {
                ...state,
                error: action.error,
                loading: false,
                success: false
            };

        case "DELIVERY_ADDRESS_FORM_LOADING":
            return {
                ...state,
                error: false,
                success: false,
                loading: true
            }

        case "DELIVERY_ADDRESS_FORM_RESET":
            return deliveryAddressFormDefaultState;

        default:
            return state;
    }
};